// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_6d-0";
export var eligibilityCardNotEligible = "_6d-1";